/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable object-shorthand */
/* eslint-disable no-var */
/* eslint-disable prefer-const */
/* eslint-disable radix */
/* eslint-disable eqeqeq */
/* eslint-disable @angular-eslint/no-input-rename */
import { Component, OnInit, Input } from '@angular/core';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import {
  AppSelectionOptions,
  LaunchNavigator,
  RememberChoiceOptions,
  LaunchNavigatorOptions,
} from '@awesome-cordova-plugins/launch-navigator/ngx';
import { ModalController, NavController } from '@ionic/angular';
import { format, parseISO } from 'date-fns';
import { GlobalVariable } from '../global';
import { LocalStorageService } from '../services/core/local-storage.service';
import { UserApiService } from '../services/user-api.service';
import { OrderTypeSelectionPage } from '../order-type-selection/order-type-selection.page';
@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.page.html',
  styleUrls: ['./thankyou.page.scss'],
})
export class ThankyouPage implements OnInit {
  @Input('date') date;
  @Input('orderid') orderid;
  day: any;
  time: any;
  dateC: any;
  longDay;
  dateMonth;
  showTime;
  phone;

  timer: any;
  constructor(
    private modalController: ModalController,
    public globals: GlobalVariable,
    private nav: NavController,
    public storageservice: LocalStorageService,
    private server: UserApiService,
    private launchNavigator: LaunchNavigator,
    private callTo: CallNumber
  ) {
    // this.date='2023-02-02T08:25:00.944Z'
    // this.globals.giftcardData=undefined;
  }
  ionViewWillEnter() {
    let splitted;
    if (this.globals.OrderType == 'pickup') {
      console.log('pickup time', this.globals.businessData.pickup_time);
      splitted = this.globals.businessData.pickup_time.split(' ');
    } else {
      console.log('pickup time', this.globals.businessData.delivery_time);
      splitted = this.globals.businessData.delivery_time.split(' ');
    }
    if (splitted) {
      let minutes = parseInt(splitted[0]);
      console.log('splited minutes ', minutes);
      const date = new Date(this.date);
      date.setMinutes(date.getMinutes() + minutes);
      console.log('old', this.date);
      console.log('added', date.toISOString());
      this.date = date.toISOString();
    }

    // let date = new Date(this.date)
    // this.dateMonth = new Date(
    //   date.getTime() - date.getTimezoneOffset() * 60000
    // ).toLocaleDateString("en-US", { month: "short", day: "numeric" });
    this.dateMonth = new Date(this.date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
    console.log('ccc', this.dateMonth);
    this.longDay = new Date(this.date).toLocaleString('en-us', {
      weekday: 'long',
    });
    // this.dateMonth=format(parseISO(this.date), 'MMM dd');
    // this.dateMonth=this.date.
    this.phone = this.phoneConvert(this.globals.businessData.phone);

    this.convertDate(this.date);
    this.globals.couponAmount = 0;
    this.globals.giftcardData.amount = 0;
    this.globals.points_availed = 0;
    if (this.globals.guestLogin == true) {
      this.globals.guestLogin = false;
      // localStorage.clear();
      this.storageservice.setFirstName('FirstName', '');
      this.globals.udid = '';
    }
    localStorage.removeItem('cart');
    let kiosk = JSON.parse(localStorage.getItem('kiosk'));
    this.globals.kiosk_flag = kiosk;

    // 10 seconds in milliseconds
  }

  ngOnInit() {
    localStorage.setItem('isOrderTypeChange', 'false');
    this.timer = setTimeout(() => {
      console.log('hellllll');

      this.close();
    }, 10000);

    let kiosk = JSON.parse(localStorage.getItem('kiosk'));

    this.globals.kiosk_flag = kiosk;
  }
  callToNumber() {
    if (this.globals.businessData.phone) {
      this.callTo
        .callNumber(this.globals.businessData.phone, false)
        .then((res) => {
          console.log('call number response ', res);
        })
        .catch((err) =>
          console.log('number not valid or something not good', err)
        );
    }
  }
  phoneConvert(phone) {
    var cleaned = this.globals.businessData.phone.replace(/\D/g, '');
    console.log(cleaned);
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      console.log(
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3]
      );
      return (
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3]
      );
    }
    return phone;
  }
  navigateTo() {
    // this.launchNavigator.appSelection
    let rememberChoice: RememberChoiceOptions = {
      enabled: false,
    };
    let appSelection: AppSelectionOptions = {
      list: [
        this.launchNavigator.APP.GOOGLE_MAPS,
        this.launchNavigator.APP.WAZE,
        this.launchNavigator.APP.APPLE_MAPS,
        this.launchNavigator.APP.YANDEX,
        this.launchNavigator.APP.CITYMAPPER,
      ],
      rememberChoice: rememberChoice,
    };

    let options: LaunchNavigatorOptions = {
      // start: this.globals.address,
      appSelection: appSelection,
    };
    if (this.globals.businessData.address) {
      this.launchNavigator
        .navigate(this.globals.businessData.address, options)
        .then(
          (success) => {
            // this.launchNavigator.appSelection.userChoice.clear(()=>{
            //   console.log("User preferred app is cleared");
            // });
            console.log(success, 'Launched navigator');
          },
          (error) => {
            //   this.launchNavigator.appSelection.userChoice.clear(()=>{
            //     console.log("User preferred app is cleared");
            // });
            // this.globals.presentToast('Failed to navigate');
            let link =
              'https://www.google.com/maps?q=' +
              this.globals.businessData.address;
            // dfghjk
            // this.aib.create(link);
            window.open(link, '_blank').focus();

            // console.log('Error launching navigator', error);
          }
        );
    }
    // this will clear user selection..... will add to settings later.
  }
  close() {
    if (this.globals.orderOnCall) {
      localStorage.removeItem('isLogin');

      let StationId = localStorage.getItem('kioskId');
      let printerId = localStorage.getItem('printerId');

      localStorage.clear();

      localStorage.setItem('kioskId', StationId);
      localStorage.setItem('printerId', printerId);
      this.globals.udid = '';
      this.orderTypePage();
    }

    if (this.globals.inWeb) {
      this.nav.navigateRoot('/order');
    } else {
      this.nav.navigateRoot('/tabs/tabs/home');
    }
    clearTimeout(this.timer);
    this.modalController.dismiss();
  }

  async orderTypePage() {
    let modal = await this.modalController.create({
      component: OrderTypeSelectionPage,

      cssClass: 'orderTypeModal',
      mode: 'ios',
      backdropDismiss: false,
      swipeToClose: false,
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      console.log(data);
    });
  }

  convertDate(date) {
    console.log('sending to api', date);
    this.server.date_convert(date).subscribe(
      (data) => {
        console.log(data);

        this.day = data.day;
        let time = data.time;
        time = time.split('.');
        console.log(time);
        let hours = time[0];
        let mins = time[1];
        console.log(date, hours, mins);

        (this.time = this.tConvert(hours + ':' + mins)),
          (this.dateC = data.date);
        this.showTime = this.convertTime(this.time);
        // this.tConvert(data.time) for
      },
      (err) => {
        console.log(err);
      }
    );
  }
  convertTime(time) {
    if (time) {
      let newtime = time.split(':');
      console.log('time array ', newtime);
      let hour = newtime[0];
      let min = newtime[1];
      if (Number(hour) < 9) {
        hour = '0' + hour;
      }
      return hour + ':' + min;
    }
  }
  tConvert(time) {
    console.log(time, 'convrt time');
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM ' : ' PM '; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }
}
